module.exports = __webpack_public_path__ + "static/media/Ascending.Inactive.109137dc.svg";